import React from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';
import { Intl } from 'components';

export default ( { children, onSaveFavourite, id = 0 } ) => (
  <Row className="align-items-center mb-2">
    <Col>
      {children}
    </Col>
    {!!onSaveFavourite
    && (
    <Col xs="auto" className="pl-0">
      <i
        className="fa fa-save fa-lg text-gray-7 cursor-pointer"
        id={`saveFavouriteBtn-${id}`}
        onClick={onSaveFavourite}
      />
      <UncontrolledTooltip
        delay={0}
        target={`saveFavouriteBtn-${id}`}
        offset="-30,8"
        className="campaign-wizard-tooltip"
      >
        <Intl id="saveToFavorites" />
      </UncontrolledTooltip>
    </Col>
    )}
  </Row>
);
